import * as React from 'react'
import {pure} from 'recompose'
import {StatisticsBase, StatisticsSubpage} from './statistics-base'

interface Props {
  page?: StatisticsSubpage
}

export const Statistics = pure((props: Props) => (
  <StatisticsBase subpage={props.page ?? 'report'} />
))
